const projectList = [
  {
    title: 'Job Crawler',
    summary:
      'A custom web crawling algorithm that ingests company sec information, searches for careers/ats pages and adds the job postings into a Postgres db.',
    stack: ['Java', 'Spring Boot', 'Postgres', 'Docker', 'React'],
    highlights: [
      'Automated company discovery, domain resolution and ATS/careers page discovery pipeline',
      'Postgres-backed search and crawl observability',
      '(Currently under construction)'
    ],
    links: [
      { label: 'Visit Site', href: 'https://jobcrawler.shabitbhatt.com' },
    ],
    featured: true,
  },


  {

    
    title: 'Text Editor',
    summary:
      'A lightweight terminal based text editor developed using in C++. Supports basic text editor features such as syntax highlighting, edit/view modes, auto-saving, etc.',
    stack: ['C++', 'Terminal UI', 'Makefile'],
    highlights: [
      'Extremely lightweight',
      'Undo/redo command system',
      'Syntax highlighting for C, C++, and Python',
      'Licensed under the MIT License'

    ],
    links: [
      { label: 'Visit Repo', href: 'https://github.com/s-b-i-t/TextEditor' },
    ],
    featured: true,
  },
  {
    title: 'Polynomial Calculator',
    summary:
      'A browser-based calculator for polynomial and complex number arithmetic, powered by C++ compiled to WebAssembly with a Vue interface.',
    stack: ['C++', 'WebAssembly', 'Vue', 'JavaScript'],
    highlights: [
      'C++ computation speed on a web browser',
      'Vue interface for entering expressions and viewing results',
    ],
    links: [
      { label: 'Visit Site', href: 'https://polycalc.shabitbhatt.com' },
      { label: 'Visit Repo', href: 'https://github.com/s-b-i-t/PolyCalc' },
    ],
    featured: true,
  },
  {
    title: 'Farm Dashboard',
    summary:
      'A senior design dashboard for tracking weather and farm data, with charts, and predictions for campus use.',
    stack: ['React', 'Flask', 'Chart.js', 'Python'],
    highlights: [
      'Weather and station data views',
      'Prediction workflow backed by ML models',
    ],
    links: [
      { label: 'Visit Site', href: 'https://spring-valley-dashboard.pages.dev/' },
    ],
    featured: false,
  },
  {
    title: 'IEEE Branch Site',
    summary:
      'A React site for the IEEE student branch at UConn focused on events, chapter visibility, and giving the organization a more active web presence.',
    stack: ['React', 'JavaScript', 'CSS'],
    highlights: [
      'Used for highlighting chapter events',
    ],
    links: [
      { label: 'Visit Site', href: 'https://pels-pes-chapter.pages.dev/' },
    ],
    featured: false,
  },
  
];

function Projects() {
  return (
    <section className="page-shell projects-page">
<div className="page-hero projects-hero">
  <p className="eyebrow">Projects</p>
  <h1>Project Gallery</h1>
  <p className="hero-copy muted-copy">
      Backend systems, deployed apps, C++ tools, and data-focused web projects I've developed over the years.
  </p>
</div>

      <div className="project-grid">
        {projectList.map((project) => (
          <article key={project.title} className="project-card">
            <h2>{project.title}</h2>

            <p className="project-card-copy">{project.summary}</p>
            <p className="project-stack">{project.stack.join(' · ')}</p>

            <ul className="project-highlights">
              {project.highlights.map((highlight) => (
                <li key={highlight}>{highlight}</li>
              ))}
            </ul>

            <div className="project-links">
              {project.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="project-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export { projectList };
export default Projects;
